module.exports = __webpack_public_path__ + "img/new_realpleyer02.f94946d7.png";